<template>
  <div v-if="!isMobile" id="page">
    <nav id="navBar">
      <v-app-bar app class="navApp" prominent dense>
        <v-container class="d-flex justify-space-between">
          <DateTimePicker :values1="dateTime1" :values2="dateTime2" :updateData="updateData" :dateApplied="dateApplied" :isClose="isClose" :selectD="selectD" />

          <div style="padding-right:100px">
            <span style="font-size: 0.98vw;">{{ location[0] }} | {{ sn[0] }}</span>
            <div>
              <v-autocomplete @change="updateConsole" v-model="$route.params.id" :items="smpDataConsole" return-object dense prepend-icon="mdi-database-search" class="select"></v-autocomplete>
            </div>
          </div>
          <div>
            <v-row>
              <v-tooltip bottom v-if="resetTimeRange">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="info darken-1" class="ma-1 white--text" fab small v-bind="attrs" v-on="on" @click="resetTrange(resetLoad)">
                    <v-icon color="white">
                      mdi-restart
                    </v-icon>
                  </v-btn>
                </template>
                <span>Reset Time Range</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :loading="loading5" :disabled="loading5" :color="!timer ? 'red' : 'green'" :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text'" @click="(timer = !timer), (loader = 'loading5')" min-width="10" fab small v-bind="attrs" v-on="on">
                    <v-icon dark>
                      {{ !timer ? "mdi-play" : "mdi-pause" }}
                    </v-icon>
                  </v-btn>
                </template>
                <span> {{ !timer ? "Enable Auto Refresh Page" : "Disable Auto Refresh Page" }}</span>
              </v-tooltip>
              <v-btn v-on="on" color="info" small fab @click="darkMode" class="ma-1">
                <v-icon color="yellow">mdi-white-balance-sunny</v-icon>
              </v-btn>

              <xlsx-workbook>
                <xlsx-sheet v-for="sheet in sheets" :key="sheet.name" :sheet-name="sheet.name" :collection="sheet.data" />
                <xlsx-download :filename="`Report ${this.location[0]}.xlsx`" class="ma-1">
                  <v-btn color="primary" small fab>
                    <v-icon>
                      mdi-download
                    </v-icon>
                  </v-btn>
                </xlsx-download>
              </xlsx-workbook>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="yellow darken-1" class="ma-1 white--text" @click="printPage" fab small v-bind="attrs" v-on="on">
                    <v-icon dark>
                      mdi-printer
                    </v-icon>
                  </v-btn>
                </template>
                <span>Print / Save</span>
              </v-tooltip>
            </v-row>
          </div>
        </v-container>
      </v-app-bar>
    </nav>

    <v-row class="ma-0">
      <v-container class="reportTitle">
        <h2 justify="center" align="center" class="mb-3">{{ location[0] }}</h2>
        <h3 justify="center" align="center">Report for {{ formatDate(values1) }} - {{ formatDate(values2) }}</h3>
        <p justify="center" align="center" style="color:grey; font-size: 14px;">Generated at: {{ dateNow() }}</p>
      </v-container>

      <v-col class="pa-3 d-flex flex-column" v-if="loading == true">
        <v-skeleton-loader height="200" width="1620" type="card"></v-skeleton-loader>
      </v-col>
      <v-col class="pa-3 d-flex flex-column" v-else>
        <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
        <v-card v-else width="1800" class="elevation-5 flex d-flex flex-column">
          <HereMap :center="map(latitude[0], longitude[0])" v-if="renderComponent" />
        </v-card>
      </v-col>
    </v-row>

    <br />

    <v-card-title>Alert</v-card-title>
    <v-row class="ma-0" id="alertTableUi">
      <v-col class="pa-3 d-flex flex-column">
        <v-card-text v-if="event.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
        <v-simple-table height="330px" :width="width" v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  #
                </th>
                <th class="text-left">
                  Date
                </th>
                <th class="text-left">
                  Time (24-hour)
                </th>
                <th class="text-left">
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in event" :key="idx">
                <td>{{ idx + 1 }}</td>
                <td>
                  {{ formatDay(item.timestamp) }}
                  {{ formatMonth(item.timestamp) }}
                  {{ formatYear(item.timestamp) }}
                </td>
                <td>{{ formatTimeTd(item.timestamp) }}</td>
                <td>
                  {{ eventDesc(item.fields.event_id, item.fields.seismic_data.mag, item.fields.seismic_data.angle, item.fields.sound_data.sound, item.fields.sound_data.evt_duration, item.fields.air_quality_data.density, item.fields.air_quality_data.co, item.fields.air_quality_data.no2, item.fields.air_quality_data.nh3, item.fields.weather_data.amb_temp, item.fields.weather_data.humidity) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row class="ma-0" id="alertTablePrinter">
      <v-col class="pa-3 d-flex flex-column">
        <v-card-text v-if="event.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
        <v-simple-table :width="width" v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  #
                </th>
                <th class="text-left">
                  Date
                </th>
                <th class="text-left">
                  Time (24-hour)
                </th>
                <th class="text-left">
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in event" :key="idx">
                <td>{{ idx + 1 }}</td>
                <td>
                  {{ formatDay(item.timestamp) }}
                  {{ formatMonth(item.timestamp) }}
                  {{ formatYear(item.timestamp) }}
                </td>
                <td>{{ formatTimeTd(item.timestamp) }}</td>
                <td>
                  {{ eventDesc(item.fields.event_id, item.fields.seismic_data.mag, item.fields.seismic_data.angle, item.fields.sound_data.sound, item.fields.sound_data.evt_duration, item.fields.air_quality_data.density, item.fields.air_quality_data.co, item.fields.air_quality_data.no2, item.fields.air_quality_data.nh3, item.fields.weather_data.amb_temp, item.fields.weather_data.humidity) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <br />

    <div class="pagebreak"></div>

    <v-row class="ma-0">
      <v-col class="pa-3 d-flex flex-column">
        <v-skeleton-loader v-if="loading == true" :height="height" :width="width" type="card-heading,card"></v-skeleton-loader>
        <v-card class="elevation-5 flex d-flex flex-column" v-else>
          <v-card-title primary>
            <v-img :src="require('../../assets/Vibration.png')" max-height="60" max-width="60" />
            <span class="font-weight-bold" style="font-size: 16px">Vibration X-Y-Z Axis(PPV)</span>
          </v-card-title>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else>
            <SeismicChart :seismicSeries="seismicSeries" :height="height" :width="width" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card color="red" dark v-if="eventSeismic > 10" class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Vibration Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>
                ⚪ Threshold level is 5 mm/s
                <br />
                ⚪ Longest continuous breach is 1 minute 20 seconds
              </span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw;">{{ eventSeismic }}</v-card-text>
        </v-card>
        <v-card v-else class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Vibration Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>
                ⚪ Threshold level is 5 mm/s
                <br />
                ⚪ Longest continuous breach is 1 minute 20 seconds
              </span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw;">{{ eventSeismic }}</v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Longest Vibration</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ Math.max(...duration) }} <span style="font-size: 1vw">s</span></v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- <div class="pagebreak"></div> -->

    <v-row class="ma-0">
      <v-col class="pa-3 d-flex flex-column">
        <v-skeleton-loader v-if="loading == true" :height="height" :width="width" type="card-heading,card"></v-skeleton-loader>
        <v-card class="elevation-5 flex d-flex flex-column" v-else>
          <v-card-title primary>
            <v-img :src="require('../../assets/Vibration.png')" max-height="60" max-width="60" />
            <span class="font-weight-bold" style="font-size: 16px">Vibration Consolidated(PPV)</span>
          </v-card-title>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else>
            <MagChart :magSeries="magSeries" :height="height" :width="width" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Peak Vibration Detected</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ Math.max(...mag) }} <span style="font-size: 1vw">mm/s</span></v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div class="pagebreak"></div>

    <v-row class="ma-0">
      <v-col class="pa-3 d-flex flex-column">
        <v-skeleton-loader v-if="loading == true" :height="height" :width="width" type="card-heading,card"></v-skeleton-loader>
        <v-card class="elevation-5 flex d-flex flex-column" v-else>
          <v-card-title primary>
            <v-img :src="require('../../assets/Tilting03.png')" max-height="60" max-width="60" />
            <span class="font-weight-bold" style="font-size: 16px">Permanent Tilting</span>
          </v-card-title>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else>
            <AngleChart :angleSeries="angleSeries" :height="height" :width="width" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card color="red" dark v-if="eventTilting > 10" class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Tilt Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>
                ⚪ Threshold level is 5 ∠
              </span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw;">{{ eventTilting }}</v-card-text>
        </v-card>
        <v-card v-else class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Tilt Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>
                ⚪ Threshold level is 5 ∠
              </span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw;">{{ eventTilting }}</v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Worst Tilt Detected</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ Math.max(...angle) }} <span style="font-size: 1vw">∠</span></v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div class="pagebreak"></div>

    <v-row class="ma-0">
      <v-col class="pa-3 d-flex flex-column">
        <v-skeleton-loader v-if="loading == true" :height="height" :width="width" type="card-heading,card"></v-skeleton-loader>
        <v-card class="elevation-5 flex d-flex flex-column" v-else>
          <v-card-title primary>
            <v-img :src="require('../../assets/Noise.png')" max-height="60" max-width="60" />
            <span class="font-weight-bold" style="font-size: 16px">Noise Level</span>
          </v-card-title>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else>
            <SoundChart :soundSeries="soundSeries" :height="height" :width="width" />
          </v-card-text>
          <v-row class="ma-0" justify="center">
            <v-col>
              <v-card class="pa-2" outlined tile>
                <span primary style="font-size:0.8vw" v-if="smp.length == 0 || laeq.length == 0">No Data</span>
                <span primary style="font-size:0.8vw" v-else>LAeq : {{ laeq[0].toFixed(2) }} dBA</span>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" outlined tile>
                <span primary style="font-size:0.8vw" v-if="smp.length == 0 || l10.length == 0">No Data</span>
                <span primary style="font-size:0.8vw" v-else>L10 : {{ l10[0].toFixed(2) }} dBA</span>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" outlined tile>
                <span primary style="font-size:0.8vw" v-if="smp.length == 0 || l90.length == 0">No Data</span>
                <span primary style="font-size:0.8vw" v-else>L90 : {{ l90[0].toFixed(2) }} dBA</span>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" outlined tile>
                <span primary style="font-size:0.8vw" v-if="smp.length == 0 || lmin.length == 0">No Data</span>
                <span primary style="font-size:0.8vw" v-else>LAmin : {{ lmin[0].toFixed(2) }} dBA</span>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" outlined tile>
                <span primary style="font-size:0.8vw" v-if="smp.length == 0 || lmax.length == 0">No Data</span>
                <span primary style="font-size:0.8vw" v-else>LAmax : {{ lmax[0].toFixed(2) }} dBA</span>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card color="red" dark v-if="eventSound > 10" class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Noise Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>
                ⚪ Threshold level is 80 dBA
                <br />
                ⚪ Longest Continuous Breached is 10 seconds
              </span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ eventSound }}</v-card-text>
        </v-card>
        <v-card v-else class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Noise Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>
                ⚪ Threshold level is 80 dBA
                <br />
                ⚪ Longest Continuous Breached is 10 seconds
              </span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ eventSound }}</v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle">Recent Noise Lvl</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ soundDb[0] }} <span style="font-size: 1vw">dBA</span></v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Peak Noise Lvl</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ Math.max(...soundDb) }} <span style="font-size: 1vw">dBA</span></v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Longest Continuous Noise</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ Math.max(...soundDura) }} <span style="font-size: 1vw">s</span></v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div class="pagebreak"></div>

    <v-row class="ma-0">
      <v-col class="pa-3 d-flex flex-column">
        <v-skeleton-loader v-if="loading == true" :height="height" :width="width" type="card-heading,card"></v-skeleton-loader>
        <v-card class="elevation-5 flex d-flex flex-column" v-else>
          <v-card-title primary>
            <v-img :src="require('../../assets/Dust.png')" max-height="60" max-width="60" />
            <span class="font-weight-bold" style="font-size: 16px">Dust Level TSP: PM2.5</span>
          </v-card-title>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else>
            <DensityChart :densitySeries="densitySeries" :height="height" :width="width" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card color="red" dark v-if="eventDensity > 10" class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total TSP PM2.5 Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>⚪ Threshold level is 280 ug/m3</span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw;">{{ eventDensity }}</v-card-text>
        </v-card>
        <v-card v-else class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total TSP PM2.5 Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>⚪ Threshold level is 280 ug/m3</span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw;">{{ eventDensity }}</v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle">Recent TSP PM2.5</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ density[0] }} <span style="font-size: 1vw">ug/m³</span></v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Peak TSP PM2.5</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ Math.max(...density) }} <span style="font-size: 1vw">ug/m³</span></v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div class="pagebreak"></div>

    <v-row class="ma-0">
      <v-col class="pa-3 d-flex flex-column">
        <v-skeleton-loader v-if="loading == true" :height="height" :width="width" type="card-heading,card"></v-skeleton-loader>
        <v-card class="elevation-5 flex d-flex flex-column" v-else>
          <v-card-title primary>
            <v-img :src="require('../../assets/HazardousGas.png')" max-height="60" max-width="60" />
            <span class="font-weight-bold" style="font-size: 16px">Hazardous Gasses(CO,NH3,NO2)</span>
          </v-card-title>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else>
            <CompoundChart :compoundSeries="compoundSeries" :height="height" :width="width" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card color="red" dark v-if="eventGas > 10" class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Hazardous Gasses Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>
                ⚪ Threshold level for Carbon Monoxide(CO) is 30 mg/m³
                <br />
                ⚪ Threshold level for Ammonia(NH3) is 1.5 mg/m³
                <br />
                ⚪ Threshold level for Nitrogen Dioxide(NO2) is 280 ug/m³
              </span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ eventGas }}</v-card-text>
        </v-card>
        <v-card v-else class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Hazardous Gasses Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>
                ⚪ Threshold level for Carbon Monoxide(CO) is 30 mg/m³
                <br />
                ⚪ Threshold level for Ammonia(NH3) is 1.5 mg/m³
                <br />
                ⚪ Threshold level for Nitrogen Dioxide(NO2) is 280 ug/m³
              </span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ eventGas }}</v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle">Recent Hazardous Gasses</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 0.8vw">CO: {{ co[0] }} <span style="font-size: 0.8vw">mg/m³</span></v-card-text>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 0.8vw">NH3: {{ nh3[0] }} <span style="font-size: 0.8vw">mg/m³</span></v-card-text>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 0.8vw">NO2: {{ no2[0] }} <span style="font-size: 0.8vw">ug/m³</span></v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">
            Peak Hazardous Gasses
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1vw">CO: {{ Math.max(...co) }} <span style="font-size: 0.8vw">mg/m³</span></v-card-text>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1vw">NH3: {{ Math.max(...nh3) }} <span style="font-size: 0.8vw">mg/m³</span></v-card-text>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1vw">NO2: {{ Math.max(...no2) }} <span style="font-size: 0.8vw">ug/m³</span></v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Minimum Hazardous Gasses</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1vw">CO: {{ Math.min(...co) }} <span style="font-size: 0.8vw">mg/m³</span></v-card-text>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1vw">NH3: {{ Math.min(...nh3) }} <span style="font-size: 0.8vw">mg/m³</span></v-card-text>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1vw">NO2: {{ Math.min(...no2) }} <span style="font-size: 0.8vw">ug/m³</span></v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div class="pagebreak"></div>

    <v-row class="ma-0">
      <v-col class="pa-3 d-flex flex-column">
        <v-skeleton-loader v-if="loading == true" :height="height" :width="width" type="card-heading,card"></v-skeleton-loader>
        <v-card class="elevation-5 flex d-flex flex-column" v-else>
          <v-card-title primary>
            <v-img :src="require('../../assets/Temperature.png')" max-height="60" max-width="60" />
            <span class="font-weight-bold" style="font-size: 16px">Ambient Temperature</span>
          </v-card-title>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else>
            <TempChart :tempSeries="tempSeries" :height="height" :width="width" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card color="red" dark v-if="eventTemp > 10" class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Temp Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>⚪ Threshold level is 45 °C</span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw;">{{ eventTemp }}</v-card-text>
        </v-card>
        <v-card v-else class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Temp Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>⚪ Threshold level is 45 °C</span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw;">{{ eventTemp }}</v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle">Recent Temperature</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ temp[0] }} <span style="font-size: 1vw">°C</span></v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Peak Temperature</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ Math.max(...temp) }} <span style="font-size: 1vw">°C</span></v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Lowest Temperature</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ Math.min(...temp) }} <span style="font-size: 1vw">°C</span></v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div class="pagebreak"></div>

    <v-row class="ma-0">
      <v-col class="pa-3 d-flex flex-column">
        <v-skeleton-loader v-if="loading == true" :height="height" :width="width" type="card-heading,card"></v-skeleton-loader>
        <v-card class="elevation-5 flex d-flex flex-column" v-else>
          <v-card-title primary>
            <v-img :src="require('../../assets/Humidity.png')" max-height="60" max-width="60" />
            <span class="font-weight-bold" style="font-size: 16px">Ambient Relative Humidity</span>
          </v-card-title>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else>
            <HumidChart :humidSeries="humidSeries" :height="height" :width="width" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card color="red" dark v-if="eventHumid > 10" class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Humidity Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>⚪ Threshold level is 99 %RH</span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw;">{{ eventHumid }}</v-card-text>
        </v-card>
        <v-card v-else class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle"
            >Total Humidity Breach
            <v-tooltip bottom style="z-index: 100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>⚪ Threshold level is 99 %RH</span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw;">{{ eventHumid }}</v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle primary class="cardTitle">Recent Humidity</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ humid[0] }} <span style="font-size: 1vw">%RH</span></v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Peak Humidity</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ Math.max(...humid) }} <span style="font-size: 1vw">%RH</span></v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Lowest Humidity</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ Math.min(...humid) }} <span style="font-size: 1vw">%RH</span></v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div class="pagebreak"></div>

    <v-card-title id="epUI">Equipment Properties</v-card-title>
    <v-row class="ma-0">
      <v-col class="pa-3 d-flex flex-column">
        <v-skeleton-loader v-if="loading == true" :height="height" :width="width" type="card-heading,card"></v-skeleton-loader>
        <v-card class="elevation-5 flex d-flex flex-column" v-else>
          <v-card-title primary> <v-icon x-large left color="green"> mdi-battery-charging </v-icon><span class="font-weight-bold" style="font-size: 16px">Power</span> </v-card-title>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else>
            <BattChart :battSeries="battSeries" :height="height" :width="width" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3 d-flex flex-column">
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Tamper Switch</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ eventTamper }}</v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Solar Power</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ (vsolar[0] / 1000).toFixed(2) }} <span style="font-size: 1vw">V</span></v-card-text>
        </v-card>
        <br />
        <v-card class="elevation-5 flex d-flex flex-column">
          <v-card-subtitle class="cardTitle">Battery Power</v-card-subtitle>
          <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-card-text v-else class="text-center" style="font-size: 1.5vw">{{ (vbatt[0] / 1000).toFixed(2) }} <span style="font-size: 1vw">V</span></v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card-title class="dn">Logs</v-card-title>
    <v-row class="ma-0 dn">
      <v-col class="pa-3 d-flex flex-column">
        <v-card-text v-if="smp.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
        <v-simple-table height="500px" class="tb">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Date
                </th>
                <th class="text-left">
                  Time (24-hour)
                </th>
                <th class="text-left">
                  X-axis
                </th>
                <th class="text-left">
                  Y-axis
                </th>
                <th class="text-left">
                  Z-axis
                </th>
                <th class="text-left">
                  Δ° Tilt
                </th>
                <th class="text-left">
                  Vibration (PPV)
                </th>
                <th class="text-left">
                  Noise
                </th>
                <th class="text-left">
                  Noise Dura.
                </th>
                <th class="text-left">
                  Amb. Temp
                </th>
                <th class="text-left">
                  Amb. Humid
                </th>
                <th class="text-left">
                  Dust(TSP)
                </th>
                <th class="text-left">
                  Gas CO
                </th>
                <th class="text-left">
                  Gas NH3
                </th>
                <th class="text-left">
                  Gas NO2
                </th>
                <th class="text-left">
                  Batt. (V)
                </th>
                <th class="text-left">
                  Solar. (V)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in smp" :key="i">
                <td>{{ formatDateTd(item.timestamp) }}</td>
                <td>{{ formatTimeTd(item.timestamp) }}</td>
                <td>{{ item.fields.seismic_data.x.toFixed(4) }} mm/s</td>
                <td>{{ item.fields.seismic_data.y.toFixed(4) }} mm/s</td>
                <td>{{ item.fields.seismic_data.z.toFixed(4) }} mm/s</td>
                <td>{{ item.fields.seismic_data.angle }}°</td>
                <td>{{ item.fields.seismic_data.mag }} mm/s</td>
                <td>{{ item.fields.sound_data.sound }} dBA</td>
                <td>{{ item.fields.sound_data.evt_duration }} s</td>
                <td v-if="item.fields.weather_data.amb_temp == 0">N/A</td>
                <td v-else>{{ item.fields.weather_data.amb_temp }} °C</td>
                <td v-if="item.fields.weather_data.humidity == 0">N/A</td>
                <td v-else>{{ item.fields.weather_data.humidity }} %RH</td>
                <td>{{ item.fields.air_quality_data.density }} ug/m³</td>
                <td v-if="item.fields.air_quality_data.co == 0">N/A</td>
                <td v-else>{{ item.fields.air_quality_data.co }} mg/m³</td>
                <td v-if="item.fields.air_quality_data.nh3 == 0">N/A</td>
                <td v-else>{{ item.fields.air_quality_data.nh3 }} mg/m³</td>
                <td v-if="item.fields.air_quality_data.no2 == 0">N/A</td>
                <td v-else>{{ item.fields.air_quality_data.no2 }} ug/m³</td>
                <td>{{ (item.fields.power_data.vbatt / 1000).toFixed(2) }} v</td>
                <td>{{ (item.fields.power_data.vsolar / 1000).toFixed(2) }} v</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <br />
  </div>
  <div v-else>
    <v-container class="text-center">
      <DateTimePickerMobile :values1="dateTime1" :values2="dateTime2" :updateData="updateData" :dateApplied="dateApplied" :isClose="isClose" :selectD="selectD" />
      <v-container>
        <span style="font-size: 18px;">{{ location[0] }} | {{ sn[0] }}</span>
        <div>
          <v-autocomplete @change="updateConsole(latitude[0], longitude[0])" v-model="$route.params.id" :items="smpDataConsole" return-object dense prepend-icon="mdi-database-search"></v-autocomplete>
        </div>
      </v-container>

      <v-row justify="center" align="center">
        <xlsx-workbook>
          <xlsx-sheet v-for="sheet in sheets" :key="sheet.name" :sheet-name="sheet.name" :collection="sheet.data" />
          <xlsx-download :filename="`Report ${this.location[0]}.xlsx`" class="ma-2">
            <v-btn color="primary" small>
              <v-icon left>
                mdi-download
              </v-icon>
              Generate Report
            </v-btn>
          </xlsx-download>
        </xlsx-workbook>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn :loading="loading5" :disabled="loading5" :color="!timer ? 'red' : 'green'" :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text'" @click="(timer = !timer), (loader = 'loading5')" min-width="10" fab small v-bind="attrs" v-on="on">
              <v-icon dark>
                {{ !timer ? "mdi-play" : "mdi-pause" }}
              </v-icon>
            </v-btn>
          </template>
          <span> {{ !timer ? "Enable Auto Refresh Page" : "Disable Auto Refresh Page" }}</span>
        </v-tooltip>
      </v-row>
    </v-container>

    <DetailsMobileView
      :seismicSeries="seismicSeries"
      :magSeries="magSeries"
      :angleSeries="angleSeries"
      :soundSeries="soundSeries"
      :densitySeries="densitySeries"
      :compoundSeries="compoundSeries"
      :tempSeries="tempSeries"
      :humidSeries="humidSeries"
      :battSeries="battSeries"
      :latitude="latitude"
      :longitude="longitude"
      :smp="smp"
      :duration="duration"
      :mag="mag"
      :angle="angle"
      :soundDb="soundDb"
      :soundDura="soundDura"
      :density="density"
      :co="co"
      :nh3="nh3"
      :no2="no2"
      :temp="temp"
      :humid="humid"
      :vsolar="vsolar"
      :vbatt="vbatt"
      :laeq="laeq"
      :lmin="lmin"
      :lmax="lmax"
      :l10="l10"
      :l90="l90"
      :smpEvent="smpEvent"
      :event="event"
      :renderComponent="renderComponent"
      :loading="loading"
    />
  </div>
</template>

<script>
  import Vue from "vue";
  import axios from "axios";
  import moment from "moment";
  import { mapActions, mapGetters } from "vuex";
  import HereMap from "../../components/HereMapOverview.vue";
  import DateTimePicker from "../../components/DateTimePicker.vue";
  import DateTimePickerMobile from "../../components/DateTimePickerMobile.vue";
  import SeismicChart from "../../components/SeismicChart.vue";
  import MagChart from "../../components/MagChart.vue";
  import AngleChart from "../../components/AngleChart.vue";
  import SoundChart from "../../components/SoundChart.vue";
  import TempChart from "../../components/TempChart.vue";
  import HumidChart from "../../components/HumidChart.vue";
  import DensityChart from "../../components/DensityChart.vue";
  import CompoundChart from "../../components/CompoundChart.vue";
  import BattChart from "../../components/BattChart.vue";
  import DetailsMobileView from "../../components/DetailsMobileView.vue";
  import VueApexCharts from "vue-apexcharts";
  import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx/dist/vue-xlsx.es.js";

  Vue.component("apexchart", VueApexCharts);

  class Event {
    constructor(name, value) {
      this.name = name;
      this.value = value;
      this.time = new Date();
    }
  }

  export default {
    components: {
      HereMap,
      DateTimePicker,
      DateTimePickerMobile,
      SeismicChart,
      MagChart,
      AngleChart,
      SoundChart,
      TempChart,
      HumidChart,
      DensityChart,
      CompoundChart,
      BattChart,
      DetailsMobileView,
      XlsxWorkbook,
      XlsxSheet,
      XlsxDownload,
    },
    data: () => ({
      sheets: [
        { name: "Ground Vibration", data: [] },
        { name: "Noise Level", data: [] },
        { name: "Heat Index", data: [] },
        { name: "Ambient Air", data: [] },
      ],
      events: [],
      isClose: true,
      clicked: 0,
      alignments: ["start", "center", "end"],
      center: {
        lat: 0,
        lng: 0,
      },
      renderComponent: true,
      tabs: null,
      timer: true,
      loader: null,
      loading5: false,
      loading: true,
      isMobile: true,
      polling: null,
      smp: [],
      smpData: [],
      smpDataConsole: [],
      mag: [],
      angle: [],
      event: [],
      smpEvent: [],
      sn: [],
      location: [],
      latitude: [],
      longitude: [],
      console: [],
      duration: [],
      sound: [],
      soundDb: [],
      soundDura: [],
      density: [],
      weather: [],
      temp: [],
      humid: [],
      airQuality: [],
      co: [],
      nh3: [],
      no2: [],
      vbatt: [],
      vsolar: [],
      laeq: [],
      lmin: [],
      lmax: [],
      l10: [],
      l90: [],
      report: [],
      tempEvent: [],
      humidEvent: [],
      coEvent: [],
      nh3Event: [],
      no2Event: [],

      seismicSeries: [
        {
          data: [],
        },
      ],
      magSeries: [
        {
          data: [],
        },
      ],
      angleSeries: [
        {
          data: [],
        },
      ],
      soundSeries: [
        {
          data: [],
        },
      ],
      tempSeries: [
        {
          data: [],
        },
      ],
      humidSeries: [
        {
          data: [],
        },
      ],
      densitySeries: [
        {
          data: [],
        },
      ],
      compoundSeries: [
        {
          data: [],
        },
      ],
      battSeries: [
        {
          data: [],
        },
      ],
    }),
    mounted() {
      this.loadsSmp();
      this.loadsNoise();
      this.loadsEvent();
      this.loadsReport();
      this.loadsConsoleId();
      this.intervalFetchData();
      this.onResize();
      window.addEventListener("resize", this.onResize, { passive: true });

      const theme = localStorage.getItem("dark_theme");
      if (theme) {
        if (theme === "true") {
          this.$vuetify.theme.dark = true;
        } else {
          this.$vuetify.theme.dark = false;
        }
      } else if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        this.$vuetify.theme.dark = true;
        localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
      }
    },
    computed: {
      ...mapGetters(["dateTime1", "dateTime2", "resetTimeRange"]),
      height() {
        var view = this.$vuetify.breakpoint.name;
        switch (view) {
          case "xs":
            return 120;
          case "sm":
            return 140;
          case "md":
            return 160;
          case "lg":
            return 180;
          case "xl":
            return 200;
        }
        return view;
      },
      width() {
        var view = this.$vuetify.breakpoint.name;
        switch (view) {
          case "xs":
            return 200;
          case "sm":
            return 500;
          case "md":
            return 600;
          case "lg":
            return 700;
          case "xl":
            return 1000;
        }
        return view;
      },
      titleReport() {
        var report_title = "Report " + this.location[0] + " " + this.formatDay(this.values2) + this.formatMonthReport(this.values2);
        return report_title;
      },
      eventSeismic() {
        var event = this.smpEvent;
        var a = event.filter(function(value) {
          return value === 13;
        }).length;
        var b = event.filter(function(value) {
          return value === 16;
        }).length;
        return a + b;
      },
      eventTilting() {
        var event = this.smpEvent;
        var a = event.filter(function(value) {
          return value === 14;
        }).length;
        var b = event.filter(function(value) {
          return value === 15;
        }).length;
        var c = event.filter(function(value) {
          return value === 29;
        }).length;
        return a + b + c;
      },
      eventSound() {
        var event = this.smpEvent;
        var a = event.filter(function(value) {
          return value === 18;
        }).length;
        var b = event.filter(function(value) {
          return value === 19;
        }).length;
        var c = event.filter(function(value) {
          return value === 21;
        }).length;
        return a + b + c;
      },
      eventGas() {
        var co = this.coEvent;
        var nh3 = this.nh3Event;
        var no2 = this.no2Event;
        var a = co.filter(function(value) {
          return value > 30;
        }).length;
        var b = nh3.filter(function(value) {
          return value > 1.5;
        }).length;
        var c = no2.filter(function(value) {
          return value > 280;
        }).length;
        return a + b + c;
      },
      eventTemp() {
        var event = this.tempEvent;
        var a = event.filter(function(value) {
          return value > 45;
        }).length;
        return a;
      },
      eventHumid() {
        var event = this.humidEvent;
        var a = event.filter(function(value) {
          return value > 99;
        }).length;
        return a;
      },
      eventDensity() {
        var event = this.smpEvent;
        var a = event.filter(function(value) {
          return value === 22;
        }).length;
        return a;
      },
      eventTamper() {
        var event = this.smp;
        var a = event.map((sts) => sts.fields.tmper_sts);
        var b = a[0];
        if (b == 0) {
          return "Close";
        } else {
          return "Open";
        }
      },
    },
    methods: {
      ...mapActions(["resetTrange"]),
      resetLoad() {
        this.loadsSmp();
        this.loadsNoise();
        this.loadsEvent();
        this.loadsReport();
        this.loadsConsoleId();
      },

      printPage() {
        window.print();
      },

      dateApplied(date1, date2) {
        this.events.unshift(new Event("date-applied", `${date1.toString()}`));
        this.values1 = this.events[0].value;

        this.events.unshift(new Event("date-applied", `${date2.toString()}`));
        this.values2 = this.events[0].value;

        this.updateData(this.events);

        this.isClose = true;

        this.clicked = 0;
      },

      selectD(date1, date2) {
        this.clicked++;
        if (this.clicked === 2) {
          this.dateApplied(date1, date2);
          this.clicked = 0;
        }
      },
      loadsSmp: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/smp/details/" + this.$route.params.id + "/" + this.dateTime1 + "-" + this.dateTime2;
        axios
          .get(apiURL)
          .then((res) => {
            this.smp = res.data;
            this.sn = res.data.map((sn) => sn.tags.sn);
            this.console = res.data.map((console) => console.tags.consoleId);
            this.location = res.data.map((loc) => loc.location[0].location);
            this.latitude = res.data.map((lat) => lat.fields.location_data.latitude).filter((lat) => lat !== 0);
            this.longitude = res.data.map((lon) => lon.fields.location_data.longitude).filter((lon) => lon !== 0);
            this.duration = res.data.map((duration) => duration.fields.seismic_data.evt_duration);
            this.mag = res.data.map((mag) => mag.fields.seismic_data.mag);
            this.angle = res.data.map((angle) => angle.fields.seismic_data.angle);
            this.soundDb = res.data.map((db) => db.fields.sound_data.sound);
            this.soundDura = res.data.map((dura) => dura.fields.sound_data.evt_duration);
            this.temp = res.data.filter((temp) => temp.fields.weather_data.amb_temp > 0).map((temp) => temp.fields.weather_data.amb_temp);
            this.humid = res.data.filter((humid) => humid.fields.weather_data.humidity > 0).map((humid) => humid.fields.weather_data.humidity);
            this.density = res.data.map((density) => density.fields.air_quality_data.density);
            this.co = res.data.filter((co) => co.fields.air_quality_data.co > 0).map((co) => co.fields.air_quality_data.co);
            this.nh3 = res.data.filter((nh3) => nh3.fields.air_quality_data.nh3 > 0).map((nh3) => nh3.fields.air_quality_data.nh3);
            this.no2 = res.data.filter((no2) => no2.fields.air_quality_data.no2 > 0).map((no2) => no2.fields.air_quality_data.no2);
            this.vbatt = res.data.map((batt) => batt.fields.power_data.vbatt);
            this.vsolar = res.data.map((solar) => solar.fields.power_data.vsolar);

            this.renderComponent = false;
            this.$nextTick(() => {
              this.renderComponent = true;
            });

            let xData = this.smp.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.seismic_data.x,
              };
            });

            let yData = this.smp.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.seismic_data.y,
              };
            });

            let zData = this.smp.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.seismic_data.z,
              };
            });

            this.seismicSeries = [
              {
                name: "X",
                data: xData,
              },
              {
                name: "Y",
                data: yData,
              },
              {
                name: "Z",
                data: zData,
              },
            ];

            let magData = this.smp.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.seismic_data.mag,
              };
            });

            this.magSeries = [
              {
                name: "Velocity",
                data: magData,
              },
            ];

            let angleData = this.smp.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.seismic_data.angle,
              };
            });

            this.angleSeries = [
              {
                name: "Tilting",
                data: angleData,
              },
            ];

            let soundData = this.smp.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.sound_data.sound,
              };
            });

            this.soundSeries = [
              {
                name: "Sound",
                data: soundData,
              },
            ];

            let tempData = this.smp
              .filter((temp) => temp.fields.weather_data.amb_temp > 0)
              .map((e) => {
                return {
                  x: e.timestamp,
                  y: e.fields.weather_data.amb_temp,
                };
              });

            this.tempSeries = [
              {
                name: "Temperature",
                data: tempData,
              },
            ];

            let humidData = this.smp
              .filter((humid) => humid.fields.weather_data.humidity > 0)
              .map((e) => {
                return {
                  x: e.timestamp,
                  y: e.fields.weather_data.humidity,
                };
              });

            this.humidSeries = [
              {
                name: "Humidity",
                data: humidData,
              },
            ];

            let densityData = this.smp.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.air_quality_data.density,
              };
            });

            this.densitySeries = [
              {
                name: "PM2.5",
                data: densityData,
              },
            ];

            let coData = this.smp
              .filter((co) => co.fields.air_quality_data.co > 0)
              .map((e) => {
                return {
                  x: e.timestamp,
                  y: e.fields.air_quality_data.co,
                };
              });

            let nh3Data = this.smp
              .filter((nh3) => nh3.fields.air_quality_data.nh3 > 0)
              .map((e) => {
                return {
                  x: e.timestamp,
                  y: e.fields.air_quality_data.nh3,
                };
              });

            let no2Data = this.smp
              .filter((no2) => no2.fields.air_quality_data.no2 > 0)
              .map((e) => {
                return {
                  x: e.timestamp,
                  y: e.fields.air_quality_data.no2,
                };
              });

            this.compoundSeries = [
              {
                name: "Carbon monoxide",
                data: coData,
              },
              {
                name: "Ammonia",
                data: nh3Data,
              },
              {
                name: "Nitrogen Dioxide",
                data: no2Data,
              },
            ];

            let vbattData = this.smp.map((e) => {
              return {
                x: e.timestamp,
                y: (e.fields.power_data.vbatt / 1000).toFixed(2),
              };
            });

            let vsolarData = this.smp.map((e) => {
              return {
                x: e.timestamp,
                y: (e.fields.power_data.vsolar / 1000).toFixed(2),
              };
            });

            this.battSeries = [
              {
                name: "Battery Power",
                data: vbattData,
              },
              {
                name: "Solar Power",
                data: vsolarData,
              },
            ];
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loading = false));
      },
      loadsEvent: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/smp/alert/" + this.$route.params.id + "/" + this.dateTime1 + "-" + this.dateTime2;
        axios
          .get(apiURL)
          .then((res) => {
            this.event = res.data;
            this.smpEvent = res.data.map((event) => event.fields.event_id);
            this.coEvent = res.data.filter((co) => co.fields.event_id == 0 || co.fields.event_id == 30).map((co) => co.fields.air_quality_data.co);
            this.nh3Event = res.data.filter((nh3) => nh3.fields.event_id == 0 || nh3.fields.event_id == 30).map((nh3) => nh3.fields.air_quality_data.nh3);
            this.no2Event = res.data.filter((no2) => no2.fields.event_id == 0 || no2.fields.event_id == 30).map((no2) => no2.fields.air_quality_data.no2);
            this.tempEvent = res.data.filter((temp) => temp.fields.event_id == 0 || temp.fields.event_id == 30).map((temp) => temp.fields.weather_data.amb_temp);
            this.humidEvent = res.data.filter((humid) => humid.fields.event_id == 0 || humid.fields.event_id == 30).map((humid) => humid.fields.weather_data.humidity);
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsReport: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/smp/seismic/report/" + this.$route.params.id + "/" + this.dateTime1 + "-" + this.dateTime2;
        axios
          .get(apiURL)
          .then((res) => {
            this.report = res.data;
            let seismicData = this.report.map((e) => {
              return {
                "Console ID": e.tags.consoleId,
                "Date/Time": e.UpdateNewDt,
                "X(mm/s)": e.fields.seismic_data.x,
                "Y(mm/s)": e.fields.seismic_data.x,
                "Z(mm/s)": e.fields.seismic_data.x,
                "Tilting(°)": e.fields.seismic_data.angle,
                "Velocity(mm/s)": e.fields.seismic_data.mag,
              };
            });
            let soundData = this.report.map((e) => {
              return {
                "Console ID": e.tags.consoleId,
                "Date/Time": e.UpdateNewDt,
                "Noise(dB)": e.fields.sound_data.sound,
                "Noise Duration(mm/s)": e.fields.sound_data.evt_duration,
              };
            });
            let aqData = this.report.map((e) => {
              return {
                "Console ID": e.tags.consoleId,
                "Date/Time": e.UpdateNewDt,
                "Ambient Temperature(°C)": e.fields.weather_data.amb_temp,
                "Ambient Humidity(%RH)": e.fields.weather_data.humidity,
              };
            });
            let gasData = this.report.map((e) => {
              return {
                "Console ID": e.tags.consoleId,
                "Date/Time": e.UpdateNewDt,
                "Particulate Matter 2.5(ug/m3)": e.fields.air_quality_data.density,
                "Carbon Monoxide(mg/m3)": e.fields.air_quality_data.co,
                "Ammonia(mg/m3)": e.fields.air_quality_data.nh3,
                "Nitrogen Dioxide(ug/m3)": e.fields.air_quality_data.no2,
              };
            });
            this.sheets[0].data = seismicData;
            this.sheets[1].data = soundData;
            this.sheets[2].data = aqData;
            this.sheets[3].data = gasData;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      darkMode() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
      },
      eventDesc(value, mag, angle, soundDb, duration_sound, density, co, noTwo, nhThree, temp, humid) {
        var velo = mag;
        var tilt = angle;
        var noise = soundDb;
        var soundDura = duration_sound;
        var dust = density;
        var cbnDxd = co;
        var ntgDxd = noTwo;
        var amnia = nhThree;
        var tempe = temp;
        var humidi = humid;
        switch (value) {
          case 13:
            return `Peak Vibration Level : ${velo} mm/s. Max ALLOWED is 5.0mm/s..`;
          case 14:
            return `Permanent tilting detected: ${tilt}° from previous position`;
          case 15:
            return `Severe tilting detected: ${tilt}° from previous position`;
          case 16:
            return "Peak Particles Velocity(PPV) continuously > ALLOWED 5.0 mm/s for 1m 20sec.";
          case 17:
            return "Unit enclosure is OPENED!";
          case 18:
            return `Noise level > ALLOWED 80 dBa and lasted OVER ${soundDura} seconds limit`;
          case 19:
            return `Noise Peak Level: ${noise} dBa. Limit is 90 dBa(7am-7pm) & 85 dBa(7pm-7am).`;
          case 21:
            return `Noise Continuous Breached at ${noise} dBa. Duration recorded: ${soundDura} secs.`;
          case 22:
            return `Dust Level (PM2.5) breach at: ${dust} ug/m3.`;
          case 29:
            return `Permanent tilting detected: ${tilt}° from previous position`;
          case 31:
            return "Unit enclosure is CLOSED!";
          default:
            if (cbnDxd > 30) {
              return `Carbon Monoxide (CO) Level: ${cbnDxd}mg/m. Threshold is 30mg/m3.`;
            } else if (ntgDxd > 280) {
              return `Nitrogen Dioxide (NO2) Level: ${ntgDxd}µg/m3. Threshold is 280µg/m3.`;
            } else if (amnia > 1.5) {
              return `Ammonia (NH3) Level: ${amnia}mg/m. Threshold is 1.5mg/m3.`;
            } else if (tempe > 45) {
              return `Ambient Temperature: ${tempe}°C. Threshold is 45°C.`;
            } else if (humidi > 99) {
              return `Humidity: ${humidi}%RH. Threshold is 99%RH.`;
            }
        }
      },
      map(lat, lon) {
        return (this.center = {
          lat: lat,
          lng: lon,
        });
      },
      intervalFetchData: function() {
        this.polling = setInterval(() => {
          if (moment(this.dateTime2).diff(moment(this.dateTime1), "minutes") == 60 && this.timer == true && moment().diff(moment(this.dateTime2), "minutes") <= 2) {
            this.values1 = moment()
              .subtract(1, "hour")
              .toDate();
            this.values2 = moment().toDate();
            this.$store.commit("setDateTime1", this.values1);
            this.$store.commit("setDateTime2", this.values2);
            this.loadsSmp(), this.loadsNoise(), this.loadsEvent(), this.loadsReport();
          } else if (moment(this.dateTime2).diff(moment(this.dateTime1), "minutes") == 180 && this.timer == true && moment().diff(moment(this.dateTime2), "minutes") <= 2) {
            this.values1 = moment()
              .subtract(3, "hour")
              .toDate();
            this.values2 = moment().toDate();
            this.$store.commit("setDateTime1", this.values1);
            this.$store.commit("setDateTime2", this.values2);
            this.loadsSmp(), this.loadsNoise(), this.loadsEvent(), this.loadsReport();
          } else if (moment(this.dateTime2).diff(moment(this.dateTime1), "minutes") == 720 && this.timer == true && moment().diff(moment(this.dateTime2), "minutes") <= 2) {
            this.values1 = moment()
              .subtract(12, "hour")
              .toDate();
            this.values2 = moment().toDate();
            this.$store.commit("setDateTime1", this.values1);
            this.$store.commit("setDateTime2", this.values2);
            this.loadsSmp(), this.loadsNoise(), this.loadsEvent(), this.loadsReport();
          } else if (this.timer == true) {
            this.loadsSmp(), this.loadsNoise(), this.loadsEvent(), this.loadsReport();
          }
        }, 60000);
      },
      onResize() {
        this.isMobile = window.innerWidth < 700;
      },
      dateNow() {
        return moment().format("ddd DD MMM YYYY, h:mm:ss a");
      },
      formatDate(value) {
        return moment(value).format("ddd DD MMM YYYY, h:mm:ss a");
      },
      formatMonthReport(value) {
        return moment(value).format("MMMYY");
      },
      formatDateTd(value) {
        return moment(value).format("DD MMM YY");
      },
      formatDay(value) {
        return moment(value).format("DD");
      },
      formatTimeTd(value) {
        return moment(value).format("HH:mm:ss");
      },
      formatTime(value) {
        return moment(value).format("H:mm:ss");
      },
      formatMonth(value) {
        return moment(value).format("MMMM");
      },
      formatYear(value) {
        return moment(value).format("YYYY");
      },
      loadsNoise: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/smp/noise/" + this.$route.params.id + "/" + this.dateTime1 + "-" + this.dateTime2;
        axios
          .get(apiURL)
          .then((res) => {
            this.laeq = res.data.map((laeq) => laeq.laeq);
            this.lmin = res.data.map((lmin) => lmin.lmin);
            this.lmax = res.data.map((lmax) => lmax.lmax);
            this.l10 = res.data.map((per10) => per10.l10);
            this.l90 = res.data.map((per90) => per90.l90);
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsConsoleId: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/smpData/console";
        axios
          .get(apiURL)
          .then((res) => {
            this.smpData = res.data;
            this.smpDataConsole = res.data.map((console) => console.consoleId);
          })
          .catch((error) => {
            console.log(error);
          });
      },

      updateConsole() {
        this.loadsSmp();
        this.loadsNoise();
        this.loadsEvent();
        this.loadsReport();
        this.loading = true;
      },

      updateData(values) {
        this.$store.commit("setReset", true);

        this.values1 = values[1].value;
        this.values2 = values[0].value;
        this.$store.commit("setDateTime1", this.values1);
        this.$store.commit("setDateTime2", this.values2);

        if (moment(this.values2).diff(moment(this.values1), "minutes") == 60 && moment(this.values2) == moment()) {
          this.values1 = moment()
            .subtract(1, "hour")
            .toDate();
          this.values2 = moment().toDate();
          this.loadsSmp();
        } else if (moment(this.values2).diff(moment(this.values1), "minutes") == 180 && moment(this.values2) == moment()) {
          this.values1 = moment()
            .subtract(3, "hour")
            .toDate();
          this.values2 = moment().toDate();
          this.loadsSmp();
        } else if (moment(this.values2).diff(moment(this.values1), "minutes") == 720 && moment(this.values2) == moment()) {
          this.values1 = moment()
            .subtract(12, "hour")
            .toDate();
          this.values2 = moment().toDate();
          this.loadsSmp();
        } else {
          this.values1 = values[1].value;
          this.values2 = values[0].value;
          this.loadsSmp();
        }
        this.loadsNoise();
        this.loadsEvent();
        this.loadsReport();
        this.loading = true;
      },
    },
    beforeDestroy() {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", this.onResize, { passive: true });
      }
      clearInterval(this.polling);
    },
    watch: {
      loader() {
        const l = this.loader;
        this[l] = !this[l];

        setTimeout(() => (this[l] = false), 500);

        this.loader = null;
      },
    },
  };
</script>

<style scoped>
  .timeDiv {
    cursor: pointer;
  }
  .layout {
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;
    margin: -12px;
  }
  table,
  th,
  td {
    border: 2px groove;
  }
  th {
    background-color: rgb(213, 205, 205);
    position: sticky;
    top: 0;
    z-index: 999;
  }
  .navApp {
    z-index: 9999;
  }
  .cardTitle {
    text-align: center;
    font-size: 0.8vw;
    font-weight: bold;
  }
  .select {
    max-width: 10.2vw;
    font-size: 0.98vw;
  }

  .reportTitle,
  #alertTablePrinter {
    display: none;
  }

  @media only print {
    html,
    body {
      width: 100%;
      margin: 0 auto;
      padding: 0;
    }
    #navBar {
      display: none;
    }
    #page {
      margin-left: -250px;
    }
    .dn,
    #alertTableUi,
    #noiseLevelUI,
    #epUI {
      display: none;
    }
    .reportTitle,
    #alertTablePrinter,
    #noiseLevelPrint {
      display: block;
    }
    .pagebreak {
      page-break-before: always;
    }
  }
</style>
